import defineComponent from 'flight';
function MemberSearchUI() {
    this.defaultAttrs({
        formSelector: '[data-form-member-search]',
        submitButtonSelector: '[data-view-detailed-search-submit]'
    });

    this._getPathname = function () {
        let pathname = location.pathname;
        if (pathname.substring(0, 2) === '//') {
            pathname = pathname.slice(1);
        }
        return pathname;
    };

    this._submitForm = function (evt) {
        evt.preventDefault();
        let form = this.select('formSelector'),
            gotoPathname = form.attr('action'),
            params = form.serialize(),
            formGotoUrl = gotoPathname + '?' + params;

        this._trackSubmit();
        this.trigger(document, 'ui:navigate', { href: formGotoUrl });
    };

    this._trackSubmit = function () {
        this.trigger(document, 'analytics:track-event', {
            category: 'Member search',
            action: 'Navigation',
            label: 'Form submit member search'
        });
    };

    this.after('initialize', function () {
        this.on('submit', {
            formSelector: this._submitForm
        });
    });
}

module.exports = defineComponent.component(MemberSearchUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/member-search-ui.js